import styled from '@emotion/styled';
import React, { useState } from 'react';
import {
	Header,
	Icon,
	IconProps,
	Segment as SemanticSegment,
	SegmentProps as SemanticSegmentProps
} from 'semantic-ui-react';

interface SegmentProps extends SemanticSegmentProps {
	fluid?: boolean;
	header?: string;
	expandable?: boolean;
}

interface ExpandIconProps extends IconProps {
	isExpanded: boolean;
}

const StyledSegment = styled(SemanticSegment, {
	shouldForwardProp: (prop) => prop !== 'fluid'
})<SegmentProps>`
	margin: 0 !important;
	padding: 0 !important;
	font-size: 14px !important;
	display: ${({ fluid }) => (fluid ? 'flex' : 'block')};
`;

const ExpandIcon = styled(Icon, {
	shouldForwardProp: (prop) => prop !== 'isExpanded'
})<ExpandIconProps>`
	font-size: 100% !important;
	vertical-align: initial !important;
	margin: 0 !important;
	padding: 0 !important;
	width: 29px !important;
	height: 29px !important;
	${(props) => !props.isExpanded && 'transform: rotate(-90deg);'}
	transition: .1s transform ease;
`;

const ExpandableWrapper = styled.div`
	cursor: pointer;
	margin-bottom: 12px;
`;

export const Segment: React.FC<SegmentProps> = (props) => {
	const [isExpanded, setIsExpanded] = useState(true);

	const handleClick = () => {
		setIsExpanded(!isExpanded);
	};

	const { expandable, header, ...rest } = props;

	return (
		<StyledSegment {...rest}>
			{header && (
				<ExpandableWrapper onClick={handleClick}>
					<Header as="h2">
						<ExpandIcon isExpanded={isExpanded} name="angle down" />
						{header}
					</Header>
				</ExpandableWrapper>
			)}
			{isExpanded && props.children}
		</StyledSegment>
	);
};
